import React, { useEffect, useState } from 'react';
import { List, Tag } from 'antd';
import { LarpTable } from '@tables';

export default function ItemRecepyWikiTable({
    item,
    allItems
}) {
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);

      useEffect(() => {
        refresh(item.recepies);
          }, // eslint-disable-next-line
      [item])

      function refresh(newDataSource)
      {
        if(!Array.isArray(newDataSource)) {
          newDataSource = item.recepies
        }

        if(newDataSource == null) {
          return;
        }
        setDataSource([...newDataSource]);
        setListSource(tableList(newDataSource, allItems))
      }

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true
        },
        {
            title: 'Items',
            key: 'items',
            render: (record) => {
                const itemsNeeded = []
                if(record.itemsNeeded !== undefined) {
                    record.itemsNeeded.forEach(itemNeed => {
                        const foundItem = allItems.find(_ => _.id === itemNeed.itemId)

                        itemsNeeded.push(`${itemNeed.amount}x ${foundItem.name}`)
                    }) 
                }

                const tags = itemsNeeded.map(_ => <Tag>{_}</Tag>)
                return tags
              }
        },
        {
            title: 'Tool level',
            dataIndex: 'toolLevel',
            key: 'toolLevel',
          },
        {
          title: 'Amount crafted',
          dataIndex: 'amountCrafted',
          key: 'amountCrafted',
        },
    ].filter(_ => !_.hidden)

    return (
      <>
        <LarpTable 
          dataSource={dataSource}
          columns={columns}
          listSource={listSource}
        />
      </>
    )
}

export function tableList(  
    list,   
    allItems
  ) {
    return list.map(_ => {

        const itemsNeeded = []
        if(_.itemsNeeded !== undefined) {
            _.itemsNeeded.forEach(itemNeed => {
                const foundItem = allItems.find(_ => _.id === itemNeed.itemId)

                itemsNeeded.push(`${itemNeed.amount}x ${foundItem.name}`)
            }) 
        }

        const tags = itemsNeeded.map(_ => <Tag>{_}</Tag>)
      return (
              <List.Item
                style={{display:"flex", flexDirection:"column"}}
              >
  
                <List.Item.Meta
                  style={{width:"100%"}}
                  title={`Amount crafted: ${_.amountCrafted}`}
                  description={`Tool level: ${_.toolLevel}`}
                />
                <div className="list-tags">
                  {tags}
                </div>
              </List.Item>
      )
    })
  }